import type { DateFieldData } from '@stratumn/studio-shared';

export const initialDateFieldData: DateFieldData = {
  title: 'Default Date Field Title',
  required: true
};
